import _TextField from "@material-ui/core/esm/TextField";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import { variables } from 'swag-client-common/styles/variables-js';
import makeInput from '../../../inputs/redux-field-makers/text-input/text-input';
import responsiveClasses from './styled-input.scss';
import fixedClasses from './styled-input-fixed.scss';
const TextInputStyled = withStyles({
  root: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: variables.colorPrimary
      }
    }
  }
})(_TextField);
export const TextInputMapping = props => {
  const {
    input,
    label,
    type,
    dataInput,
    autoComplete = '',
    children,
    hintText = '',
    disabled = false,
    className,
    isFixedStyles = false,
    meta: {
      active,
      touched,
      error
    }
  } = props;
  const shouldShownNotification = touched && !active;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextInputStyled, _extends({}, input, {
    classes: {
      root: isFixedStyles ? fixedClasses.root : responsiveClasses.root
    },
    disabled: disabled,
    type: type,
    "data-input": dataInput,
    floatingLabelText: label,
    autoComplete: autoComplete,
    hintText: hintText,
    floatingLabelFixed: true
  })), children, shouldShownNotification && /*#__PURE__*/React.createElement("span", {
    className: className
  }, error));
};
export default makeInput(TextInputMapping);